
function sliderArrowPosition(){document.querySelectorAll(".slideshow-wrapper").forEach(function(e){var t=e.querySelector(".slideshow.banner"),r=e.querySelectorAll(".slider-arrow"),n=t?.querySelector(".slideshow__media")?.offsetHeight||0;window.innerWidth<750?r.forEach(function(e){e.style.top=n/2+"px"}):r.forEach(function(e){e.style.top=""})})}function productImageDesktopArrow(){var e=document.querySelector(".product__media-wrapper");e&&e.querySelectorAll(".slider-mobile-gutter .slider-arrow").forEach(function(t){t.addEventListener("click",function(){var r=e.querySelector(".thumbnail-list").querySelector('.thumbnail-list__item button[aria-current="true"]');"next"==t.getAttribute("name")?r.parentElement.nextSibling&&r.parentElement.nextSibling.querySelector("button").click():r.parentElement.previousSibling&&r.parentElement.previousSibling.querySelector("button").click()})})}function initSlider(e,t,r){const n=document.querySelector(e);if(!n)return;let o=0;const i=n.querySelectorAll(".slider__slide").length,s=n.querySelector(".button-slide_next"),c=n.querySelector(".button-slide_prev"),l=n.querySelector(".product_cross_sells_button"),a=n.querySelector(".products_list");function d(){return window.innerWidth<=768?r:t}function u(){const e=d();i>e?(l&&(l.style.display=""),c&&c.classList.toggle("disabled",o<=0),s&&s.classList.toggle("disabled",o>=i-e)):l&&(l.style.display="none")}function y(){const e=d();o=Math.max(0,Math.min(o,i-e));const t=-o*(100/e);a&&(a.style.transform=`translateX(${t}%)`),u()}s&&s.addEventListener("click",()=>{s.classList.contains("disabled")||(o++,y())}),c&&c.addEventListener("click",()=>{c.classList.contains("disabled")||(o--,y())}),window.addEventListener("resize",()=>{y(),u()}),u(),y()}function initOrderNoteToggle(){const e=document.querySelector(".order-note-toggle"),t=document.querySelector(".order-note-content"),r=document.querySelector(".order-note-overlay");e&&e.addEventListener("click",()=>{t&&t.classList.add("active"),r&&r.classList.add("active"),document.body.style.overflow="hidden"}),document.querySelectorAll(".close-note, .order-note-overlay, .save-note").forEach(e=>{e.addEventListener("click",()=>{t&&t.classList.remove("active"),r&&r.classList.remove("active"),document.body.style.overflow="auto"})})}function initQuantityHandler(){document.body.addEventListener("click",e=>{if(e.target.matches('.box-cart .cart-item__quantity [name="minus"]')){const t=e.target.closest(".cart-quantity"),r=t?.querySelector(".quantity__input");if(0===parseFloat(r?.value||0)){e.target.style.display="none";const t=e.target.closest(".cart-item");t&&t.remove()}}})}function moveFreeshippingBar(){const e=document.querySelector(".box-total #cart-free-shipping-threshold"),t=document.querySelector(".title-wrapper-with-link"),r=document.querySelector(".box-total .js-contents");function n(){if(window.innerWidth<750){const r=t.querySelector(".cart_heading");r&&!t.querySelector(".freeshipping-bar")&&r.insertAdjacentElement("afterend",e)}else t.querySelector(".freeshipping-bar")&&r.insertBefore(e,r.firstChild)}e&&t&&r&&(n(),window.addEventListener("resize",n))}function updateFreeShippingMessage(){document.querySelectorAll(".freeshipping-bar").forEach(e=>{if(!e)return;e.classList.add("loading");const t=e.dataset.currency,r=parseFloat(e.dataset.freeShippingThreshold),n=Number(e.dataset.cartTotal)/100,o=e.querySelector(".freeshipping-message"),i=o.dataset.achievedMessage,s=o.dataset.notAchievedMessage,c=Number(window.Shopify.currency.rate),l=r*c,a=l-n,d=Math.min(n/l*100,100);if(e.setAttribute("data-rate",c),a<=0)o.textContent=i;else{const e=a.toLocaleString("VND"===t?"vi-VN":"en-US",{style:"currency",currency:t});o.textContent=s.replace("__PLACEHOLDER__",e)}const u=e.querySelector(".progress");u&&(u.style.width=d+"%"),setTimeout(()=>{e.classList.remove("loading")},10)})}document.addEventListener("DOMContentLoaded",()=>{sliderArrowPosition(),productImageDesktopArrow(),initSlider(".cart-drawer",1,1),initSlider(".cart-notification",4,2),initOrderNoteToggle(),initQuantityHandler(),moveFreeshippingBar(),updateFreeShippingMessage()}),window.addEventListener("resize",()=>{sliderArrowPosition()});

// /*
//  * Layout utilities: slideshow arrows, cart sliders, order notes,
//  * quantity handling, and free-shipping bar.
//  */

// /* ---- Slideshow arrow positioning ---- */
// function sliderArrowPosition() {
//   var slideshowWrappers = document.querySelectorAll('.slideshow-wrapper');

//   slideshowWrappers.forEach(function (slideshowWrapper) {
//     var slideshow = slideshowWrapper.querySelector('.slideshow.banner');
//     var arrows = slideshowWrapper.querySelectorAll('.slider-arrow');
//     var sliderHeight = slideshow?.querySelector('.slideshow__media')?.offsetHeight || 0;

//     if (window.innerWidth < 750) {
//       arrows.forEach(function (element) {
//         element.style.top = sliderHeight / 2 + 'px';
//       });
//     } else {
//       arrows.forEach(function (element) {
//         element.style.top = '';
//       });
//     }
//   });
// }

// function productImageDesktopArrow() {
//   var mediaWrapper = document.querySelector('.product__media-wrapper');
//   if (!mediaWrapper) return;

//   var arrows = mediaWrapper.querySelectorAll('.slider-mobile-gutter .slider-arrow');
//   arrows.forEach(function (arrow) {
//     arrow.addEventListener('click', function () {
//       var thumbnailWrapper = mediaWrapper.querySelector('.thumbnail-list');
//       var currentButton = thumbnailWrapper.querySelector('.thumbnail-list__item button[aria-current="true"]');
//       var direction = arrow.getAttribute('name');

//       if (direction == 'next') {
//         if (currentButton.parentElement.nextSibling) {
//           currentButton.parentElement.nextSibling.querySelector('button').click();
//         }
//       } else {
//         if (currentButton.parentElement.previousSibling) {
//           currentButton.parentElement.previousSibling.querySelector('button').click();
//         }
//       }
//     });
//   });
// }

// /* ---- Cart slider ---- */
// function initSlider(container, itemsPerViewDesktop, itemsPerViewMobile) {
//   const slider = document.querySelector(container);
//   if (!slider) return;

//   let index = 0;
//   const slides = slider.querySelectorAll(".slider__slide");
//   const totalSlides = slides.length;
//   const nextButton = slider.querySelector(".button-slide_next");
//   const prevButton = slider.querySelector(".button-slide_prev");
//   const buttonContainer = slider.querySelector(".product_cross_sells_button");
//   const productsList = slider.querySelector(".products_list");

//   function getItemsPerView() {
//     return window.innerWidth <= 768 ? itemsPerViewMobile : itemsPerViewDesktop;
//   }

//   function updateNavigationVisibility() {
//     const itemsPerView = getItemsPerView();

//     if (totalSlides > itemsPerView) {
//       if (buttonContainer) buttonContainer.style.display = "";
//       if (prevButton)
//         prevButton.classList.toggle("disabled", index <= 0);
//       if (nextButton)
//         nextButton.classList.toggle("disabled", index >= totalSlides - itemsPerView);
//     } else {
//       if (buttonContainer) buttonContainer.style.display = "none";
//     }
//   }

//   function showSlide() {
//     const itemsPerView = getItemsPerView();
//     index = Math.max(0, Math.min(index, totalSlides - itemsPerView));

//     const translateX = -(index * (100 / itemsPerView));
//     if (productsList) {
//       productsList.style.transform = `translateX(${translateX}%)`;
//     }

//     updateNavigationVisibility();
//   }

//   if (nextButton) {
//     nextButton.addEventListener("click", () => {
//       if (nextButton.classList.contains("disabled")) return;
//       index++;
//       showSlide();
//     });
//   }

//   if (prevButton) {
//     prevButton.addEventListener("click", () => {
//       if (prevButton.classList.contains("disabled")) return;
//       index--;
//       showSlide();
//     });
//   }

//   window.addEventListener("resize", () => {
//     showSlide();
//     updateNavigationVisibility();
//   });

//   updateNavigationVisibility();
//   showSlide();
// }

// /* ---- Order note toggle ---- */
// function initOrderNoteToggle() {
//   const orderNoteToggle = document.querySelector(".order-note-toggle");
//   const orderNoteContent = document.querySelector(".order-note-content");
//   const orderNoteOverlay = document.querySelector(".order-note-overlay");

//   if (orderNoteToggle) {
//     orderNoteToggle.addEventListener("click", () => {
//       if (orderNoteContent) orderNoteContent.classList.add("active");
//       if (orderNoteOverlay) orderNoteOverlay.classList.add("active");
//       document.body.style.overflow = "hidden";
//     });
//   }

//   document.querySelectorAll(".close-note, .order-note-overlay, .save-note").forEach((el) => {
//     el.addEventListener("click", () => {
//       if (orderNoteContent) orderNoteContent.classList.remove("active");
//       if (orderNoteOverlay) orderNoteOverlay.classList.remove("active");
//       document.body.style.overflow = "auto";
//     });
//   });
// }

// /* ---- Quantity minus button handler (delegated) ---- */
// function initQuantityHandler() {
//   document.body.addEventListener("click", (e) => {
//     if (e.target.matches('.box-cart .cart-item__quantity [name="minus"]')) {
//       const cartQuantity = e.target.closest(".cart-quantity");
//       const input = cartQuantity?.querySelector(".quantity__input");
//       let value = parseFloat(input?.value || 0);

//       if (value === 0) {
//         e.target.style.display = "none";
//         const cartItem = e.target.closest(".cart-item");
//         if (cartItem) cartItem.remove();
//       }
//     }
//   });
// }

// /* ---- Move freeshipping bar on resize ---- */
// function moveFreeshippingBar() {
//   const freeshippingBar = document.querySelector('.box-total #cart-free-shipping-threshold');
//   const titleWrapper = document.querySelector('.title-wrapper-with-link');
//   const originalParent = document.querySelector('.box-total .js-contents');
//   if (!freeshippingBar || !titleWrapper || !originalParent) return;

//   function handleResize() {
//     if (window.innerWidth < 750) {
//       const cartHeading = titleWrapper.querySelector('.cart_heading');
//       if (cartHeading && !titleWrapper.querySelector('.freeshipping-bar')) {
//         cartHeading.insertAdjacentElement('afterend', freeshippingBar);
//       }
//     } else {
//       if (titleWrapper.querySelector('.freeshipping-bar')) {
//         originalParent.insertBefore(freeshippingBar, originalParent.firstChild);
//       }
//     }
//   }

//   handleResize();
//   window.addEventListener('resize', handleResize);
// }

// /* ---- Free shipping message (global — called by other scripts) ---- */
// function updateFreeShippingMessage() {
//   const bars = document.querySelectorAll(".freeshipping-bar");

//   bars.forEach($el => {
//     if (!$el) return;

//     $el.classList.add("loading");

//     const currency = $el.dataset.currency;
//     const freeShippingThresholdBase = parseFloat($el.dataset.freeShippingThreshold);
//     const cartTotal = Number($el.dataset.cartTotal) / 100;

//     const messageEl = $el.querySelector(".freeshipping-message");
//     const achievedMessage = messageEl.dataset.achievedMessage;
//     const notAchievedTemplate = messageEl.dataset.notAchievedMessage;

//     const rate = Number(window.Shopify.currency.rate);
//     const freeShippingThreshold = freeShippingThresholdBase * rate;
//     const remaining = freeShippingThreshold - cartTotal;
//     const progress = Math.min((cartTotal / freeShippingThreshold) * 100, 100);

//     $el.setAttribute("data-rate", rate);

//     if (remaining <= 0) {
//       messageEl.textContent = achievedMessage;
//     } else {
//       const formattedRemaining = remaining.toLocaleString(
//         currency === "VND" ? "vi-VN" : "en-US",
//         { style: "currency", currency }
//       );
//       messageEl.textContent = notAchievedTemplate.replace("__PLACEHOLDER__", formattedRemaining);
//     }

//     const progressEl = $el.querySelector(".progress");
//     if (progressEl) {
//       progressEl.style.width = progress + "%";
//     }

//     setTimeout(() => {
//       $el.classList.remove("loading");
//     }, 10);
//   });
// }

// /* ---- Initialize on DOMContentLoaded ---- */
// document.addEventListener("DOMContentLoaded", () => {
//   sliderArrowPosition();
//   productImageDesktopArrow();

//   initSlider(".cart-drawer", 1, 1);
//   initSlider(".cart-notification", 4, 2);

//   initOrderNoteToggle();
//   initQuantityHandler();
//   moveFreeshippingBar();
//   updateFreeShippingMessage();
// });

// window.addEventListener("resize", () => {
//   sliderArrowPosition();
// });